var exports = {
  "x6": "AddGuildButton.module__button___NDRzWU",
  "td": "AddGuildButton.module__iconText___NDRzWU",
  "ro": "AddGuildButton.module__menuIcon___NDRzWU",
};

module.exports = exports;
